import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel } from '../../uicomponent';
import { UIComponentView } from '../../uicomponentview';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { PaginationCardViewImpl } from './paginationcardview';
import { PaginationCardCSSStyleImpl } from './paginationcardcss';
import { BaseContext } from '../../../../utils/basecontext';

export interface PaginationCardComponentProps extends UIComponentProps
{
   selectedPageNumber: number;
   paginationIndex:number;
   onSelectNext(selectedPage: number):void;
}

export interface PaginationCardComponentHandler extends UIComponentHandler
{
    onSelectNext():void;
}

export class PaginationCardComponent extends UIComponentImpl<PaginationCardComponentProps, UIComponentState, UIDataModel>
{
    constructor(props: PaginationCardComponentProps)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new PaginationCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new PaginationCardCSSStyleImpl(applicationContext);
    }

    onSelectNext(): void 
    {
        this.props.onSelectNext(this.props.paginationIndex);
    }   

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/pagination/paginationcard/paginationcardcomponent.tsx